<template>
  <td
    :class="classCss"
    v-b-tooltip="sizeGreaterThanHundred ? value : ''"
    style="font-size: 11px"
  >
    <div
      v-show="IsTextNoLink"
      v-on:click="$emit('Edit', obj)"
      href="javascript:void(0)"
      v-bind:class="{ 'text-danger': status === 0 }"
    >
      <strong
        v-if="IsStrong"
        v-bind:style="styles"
        >{{ value ? formatString(value) : '-' }}</strong
      ><span v-else>{{ value ? formatString(value) : '-' }}</span>
    </div>
    <a
      v-show="IsText"
      v-on:click="$emit('Edit', obj)"
      href="javascript:void(0)"
      v-bind:class="[{ 'text-danger': status === 0 }, classCss ? classCss : '']"
      ><strong
        v-if="IsStrong"
        v-bind:style="styles"
        >{{ value ? formatString(value) : '-' }}</strong
      ><span v-else>{{ value ? formatString(value) : '-' }}</span></a
    >
    <a
      v-show="IsDatetime"
      v-on:click="$emit('Edit', obj)"
      href="javascript:void(0)"
      v-bind:class="{ 'text-danger': status === 0 }"
      >{{ value ? formatDate(value, true) : '-' }}</a
    >
    <a
      v-show="IsDateOnly"
      v-on:click="$emit('Edit', obj)"
      href="javascript:void(0)"
      v-bind:class="{ 'text-danger': status === 0 }"
      >{{ value ? formatDate(value) : '-' }}</a
    >
    <div
      v-show="IsStatus"
      v-on:click="$emit('Edit', obj)"
    >
      <span
        v-if="status"
        class="badge badge-success text-toupper"
        >{{ $lang.Common.Status.Active }}</span
      >
      <span
        v-else
        class="badge badge-danger text-toupper"
        >{{ $lang.Common.Status.Inactive }}</span
      >
    </div>
    <div v-if="IsCustom">
      <slot></slot>
    </div>
    <div v-show="IsActionsButtons">
      <i
        v-show="HasChange"
        v-if="status"
        v-on:click="$emit('Change', obj)"
        class="fa fa-close text-danger icone-grid"
        v-b-tooltip.hover
        :title="$lang.Common.Tooltip.ButtonInactive"
      ></i>
      <i
        v-show="HasChange"
        v-else
        v-on:click="$emit('Change', obj)"
        class="fa fa-check text-success icone-grid"
        v-b-tooltip.hover
        :title="$lang.Common.Tooltip.ButtonActive"
      ></i>
      &nbsp;
      <b-dropdown
        v-show="HasDelete"
        variant="link"
        size="sm"
        no-caret
      >
        <template slot="button-content">
          <i class="fas fa-trash-alt text-secundary icone-grid"></i
          ><span class="sr-only">{{ $lang.Common.Buttons.Delete }}</span>
        </template>
        <b-dropdown-header
          ><strong>{{ $lang.Common.ConfirmDelete }}</strong></b-dropdown-header
        >
        <b-dropdown-item
          href="javascript:void(0);"
          v-on:click="$emit('Delete', obj)"
          >{{ $lang.Common.Yes }}</b-dropdown-item
        >
        <b-dropdown-item href="javascript:void(0);">{{
          $lang.Common.No
        }}</b-dropdown-item>
      </b-dropdown>
    </div>
    <div v-show="IsActionsDetails">
      <i
        v-show="HasChange"
        v-on:click="$emit('Details', obj)"
        class="fa fa-plus-square-o"
        v-b-tooltip.hover
        :title="$lang.Common.Tooltip.ButtonDetails"
      ></i>
    </div>
    <div v-show="IsInactiveButtons">
      <b-dropdown
        variant="link"
        size="sm"
        no-caret
      >
        <template slot="button-content">
          <i
            :class="iconClass"
            :style="{ color: iconColor }"
            class="cursor-pointer"
            :title="tooltip"
          ></i>
        </template>
        <b-dropdown-header>
          <strong>{{ confirmationText }}</strong>
        </b-dropdown-header>
        <b-dropdown-item
          href="javascript:void(0);"
          @click="$emit('ToggleInactive', !status)"
        >
          {{ $lang.Common.Yes }}
        </b-dropdown-item>
        <b-dropdown-item href="javascript:void(0);">
          {{ $lang.Common.No }}
        </b-dropdown-item>
      </b-dropdown>
    </div>
    <div v-show="IsLighthouse">
      <div v-show="value == 0">
        <i
          v-show="HasChange"
          class="fa fa-circle icon-background-gray font-xl"
          v-b-tooltip.hover
          title="Não contém histórico/semáforo"
        ></i>
      </div>
      <div v-show="value == 1">
        <i
          v-show="HasChange"
          class="fa fa-circle icon-background-green font-xl"
        ></i>
      </div>
      <div v-show="value == 2">
        <i
          v-show="HasChange"
          class="fa fa-circle icon-background-yellow font-xl"
        ></i>
      </div>
      <div v-show="value == 3">
        <i
          v-show="HasChange"
          class="fa fa-circle icon-background-red font-xl"
        ></i>
      </div>
      <div v-show="value == 5">
        <i
          v-show="HasChange"
          class="fa fa-circle icon-background-blue font-xl"
          v-b-tooltip.hover
          :title="description"
        ></i>
      </div>
    </div>
  </td>
</template>

<script>
export default {
  name: 'tableColumn',
  data () {
    return {
      obj: null
    }
  },
  props: {
    status: {
      type: Number,
      required: false,
      default: 0
    },
    value: {
      type: String,
      required: false,
      default: '-'
    },
    styles: {
      type: String,
      required: false,
      default: ' '
    },
    classCss: {
      type: String,
      required: false,
      default: 'text-center'
    },
    IsStrong: {
      type: Boolean,
      required: false,
      default: false
    },
    IsText: {
      type: Boolean,
      required: false,
      default: false
    },
    IsTextNoLink: {
      type: Boolean,
      required: false,
      default: false
    },
    IsDatetime: {
      type: Boolean,
      required: false,
      default: false
    },
    IsDateOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    IsStatus: {
      type: Boolean,
      required: false,
      default: false
    },
    IsActionsButtons: {
      type: Boolean,
      required: false,
      default: false
    },
    IsInactiveButtons: {
      type: Boolean,
      required: false,
      default: false
    },
    IsActionsDetails: {
      type: Boolean,
      required: false,
      default: false
    },
    IsLighthouse: {
      type: Boolean,
      required: false,
      default: false
    },
    HasChange: {
      type: Boolean,
      required: false,
      default: true
    },
    HasDelete: {
      type: Boolean,
      required: false,
      default: true
    },
    hours: {
      type: String,
      required: false,
      default: '00:00'
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    IsCustom: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    iconClass () {
      return !this.status ? 'fa fa-check' : 'fas fa-ban text-third'
    },
    iconColor () {
      return !this.status ? 'black' : 'red'
    },
    tooltip () {
      return !this.status
        ? this.$lang.Common.Tooltip.ButtonActive
        : this.$lang.Common.Tooltip.ButtonInactive
    },
    confirmationText () {
      return !this.status
        ? this.$lang.Common.Tooltip.LabelConfirmActive
        : this.$lang.Common.Tooltip.LabelConfirmInactive
    },
    sizeGreaterThanHundred () {
      return typeof this.value === 'string' ? this.value.length > 100 : false
    }
  },
  methods: {
    formatDate (d, hasTime) {
      const date = new Date(d)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      const seconds = date.getSeconds().toString().padStart(2, '0')

      return (
        `${day}/${month}/${year}` +
        (hasTime ? ` às ${hours}:${minutes}:${seconds}` : '')
      )
    },
    formatString (str) {
      if (typeof this.value !== 'string' || str.length <= 100) {
        return str
      }

      const truncated = str.slice(0, 100)
      const lastSpaceIndex = truncated.lastIndexOf(' ')

      if (lastSpaceIndex === -1) {
        return truncated + '...'
      }

      return truncated.slice(0, lastSpaceIndex) + '...'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/TableColumn.vue